import $ from "jquery";
import CONSTANT from "../../common/js/_constant";
import formHandler from "../genericForm/_genericForm";
import { load } from 'recaptcha-v3';

const expertGuidanceObj = {
  variables: {
    bg: $(".expertGuidance__section").attr("data-bg"),
    bgMob: $(".expertGuidance__section").attr("data-bg-mob"),
    fieldCount: $(".expertGuidance__section").attr("data-field"),
    bgDeskAlt: $(".expertGuidance__section__wrapper").attr("data-alt-desk"),
    bgMobAlt: $(".expertGuidance__section__wrapper").attr("data-alt-mob"),
    name : null,
    email : null,
    dob : null,
    countryCode : null,
    mobileNo : null,
    annualIncome : null,
    leadId : null,
    pincode : null,
    leadFormType : null,
    productCategory : null,
    productName : null,
    siteKey : "6LcW0h8qAAAAAO2QgLupJ0tglgpVbguVB3-IxXIp",
    city: null
  },
  methods: {
    checkTitle: function () {
      $(".expertGuidance__section__title h2").text().length > 0
        ? $(".expertGuidance__section__title").find(".primary-bar").show()
        : $(".expertGuidance__section__title").find(".primary-bar").hide();
    },
    changeBg: function (imgURL,altText) {
      $(".expertGuidance__section").css(
        "background-image",
        `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),url(${imgURL})`
      );
      $(".expertGuidance__section").attr('aria-label',`${altText}`);
    },
    alignField: function (outerVal, innerVal) {
      $(".expertGuidanceForm__container").css(
        "grid-template-columns",
        `${outerVal}`
      );
      $(".expertGuidanceForm__inner").css(
        "grid-template-columns",
        `${innerVal}`
      );
    },
    changeAlignment: function (fieldCount) {
      if (fieldCount && fieldCount === "1") {
        this.alignField("1fr 2fr", "1fr");
      } else if (fieldCount && fieldCount === "2") {
        this.alignField("2fr 1fr", "1fr 1fr");
      } else {
        this.alignField("1fr auto", "1fr 1fr 282px");
      }
    },
    closeSection : (el)=>{
      const closeContainer = $(el).find('.thankyou__close ');
      closeContainer.each(function(){
          $(this).on('click', function(){
              $(this).closest('.thankyou').addClass('d-none');
              $('body').removeClass('overflow-hidden');
            });
          });
          const closeIcon = $(el).find('.thankyou__close--icon');
          closeIcon.each(function(){
              $(this).on('click', function(){
                  $(this).closest('.thankyou').addClass('d-none');
                  $('body').removeClass('overflow-hidden');
                  //clear form fields after closing thank you section
                  const form = $(el).closest('.expertGuidance').find('.expertGuidanceForm');
                  form[0].reset();
              });
          });
    },
    buttonClickHandler: function (element,response) {
      let buttonText = $(element).find('.expertGuidance__section__cta .chli_btn--primary').text().replace(/\s+/g, ' ').trim();
      const isOtherCity = !expertGuidanceObj.variables.city || expertGuidanceObj.variables.city.toLowerCase() === 'other';
      expertGuidanceObj.variables.leadId = isOtherCity ? response.leadId : null;
      expertGuidanceObj.variables.leadFormType = response.leadFormType;
      let title = null;
      let titleElement = $(element).find('.expertGuidance__section__inner .expertGuidance__section__title h2');
      if (titleElement.length > 0) {
         title = titleElement.text().trim();
      }
      let str= title ? "form_".concat(title) : "";
      var obj = expertGuidanceObj.methods.dataLayerObj(buttonText, str);
      createDataLayer('LeadSubmitted', obj);
    },
    validateInput: function(ele){
      const inputs = $(ele).find(".expertGuidanceForm__inner__field").find('input');
      inputs.each(function(){
          $(this).on(CONSTANT.eventsListners.INPUT, function(){
              $(this).siblings('.chli_input--error').addClass('opacity-0');
              $(this).removeClass('border-red-300');
              const regex = new RegExp($(this).data('regex'));
              if(regex){
                  const inputValue = $(this).val();
                  if(inputValue === ''){
                      // Empty optional fields should not show regex invalid message.
                      $(this).siblings('.chli_input--invalid-error').addClass('opacity-0');
                      $(this).removeClass('border-red-300');
                  }else if(regex.test(inputValue)){
                      $(this).siblings('.chli_input--invalid-error').addClass('opacity-0');
                      $(this).removeClass('border-red-300');
                  }else{
                      $(this).siblings('.chli_input--invalid-error').removeClass('opacity-0');
                      $(this).addClass('border-red-300');
                  }
              }
              if($(this).prop('required') && $(this).val() == ''){
                  $(this).addClass('border-red-300');
                  $(this).siblings('.chli_input--error').addClass('opacity-0');
              }
              if($(this).hasClass('dob') && $(this).val()){
                const minAge = $(this).data('min-age');
                const maxAge = $(this).data('max-age');
                let age = new Date().getFullYear() - new Date($(this).val()).getFullYear();
                if(age < minAge || age > maxAge){
                  $(this).addClass('border-red-300');
                  $(this).siblings('.chli_input--error').addClass('opacity-0');
                }
              }
              if($(this).hasClass('annual-income') && $(this).val()){
                const minIncome = $(this).data('min-income');
                const maxIncome = $(this).data('max-income');
                let income = $(this).val();
                if(income > maxIncome || income < minIncome){
                  $(this).addClass('border-red-300');
                  $(this).siblings('.chli_input--error').removeClass('opacity-0');
                }
              }
          });
      });
      const consentCheckbox = $(ele).find('.consent__container').find('.expertGuidance__consent--checkbox');
      $(consentCheckbox).on(CONSTANT.eventsListners.CHANGE,function(){
          if(consentCheckbox.prop('required') && !consentCheckbox.is(':checked')){
              $(consentCheckbox).addClass('border-red-300');
              $(consentCheckbox).siblings('.chli_input--error').removeClass('opacity-0');
          }else{
              $(consentCheckbox).removeClass('border-red-300');
              $(consentCheckbox).siblings('.chli_input--error').addClass('opacity-0');
          }
      })
    },
    handleLoader(loader, isAdd){
      const parentLoad = $(loader).find('.spinning-loader');
      if(isAdd){
          $('body').append(parentLoad); 
          $(parentLoad).removeClass('d-none').addClass('inside-body-loader');
          $('body').css('overflow', 'hidden');
      }else{
          $('body').css('overflow', ''); 
          const loaderBody = $('body').find('.inside-body-loader');
          $(loader).append($(loaderBody).removeClass('inside-body-loader').addClass('d-none'));
      }
    },
                     dataLayerObj: function (el,e) {
                      var obj = {
                           'articleName': "",
                           'blogCategory': "",
                           'blogPageCategory': "",
                           'buttonText': el ? el : "",
                           'pageSection': e ? e : "Expert Guidance Form Component",
                           'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                           'planOption': "",
                           'productCategory': expertGuidanceObj.variables.productCategory ?? "",
                           'productName': expertGuidanceObj.variables.productName ?? "",
                           'question': "",
                           'source': "",
                           'leadForm': expertGuidanceObj.variables.leadFormType ? expertGuidanceObj.variables.leadFormType : "DST/DIGITAL",
                           'name': expertGuidanceObj.variables.name ? expertGuidanceObj.variables.name : "",
                           'email': expertGuidanceObj.variables.email ? expertGuidanceObj.variables.email : "",
                           'dob': expertGuidanceObj.variables.dob ? expertGuidanceObj.variables.dob : "",
                           'countryCode': expertGuidanceObj.variables.countryCode ? expertGuidanceObj.variables.countryCode : "",
                           'mobileNumber': expertGuidanceObj.variables.mobileNo ? expertGuidanceObj.variables.mobileNo : "",
                           'annualIncome' : expertGuidanceObj.variables.annualIncome ? expertGuidanceObj.variables.annualIncome : "",
                           'pincode' : expertGuidanceObj.variables.pincode ? expertGuidanceObj.variables.pincode : "",
                           'leadId' : expertGuidanceObj.variables.leadId ? expertGuidanceObj.variables.leadId : "",
                           'searchTerm': "",
                           'videoTitle': "",
                           'bannerName': "",
                        };
                        return obj;
                      },
    handleSubmit : (el)=>{
      const forms = $(el).find('.expertGuidanceForm');
      $(forms).each((idx,form)=>{
        $(form).on(CONSTANT.eventsListners.SUBMIT,(e)=>{
          e.preventDefault();
          let isErrors = $(el).find('.expertGuidanceForm__inner__field').find('.border-red-300');
          if(isErrors.length) {return;}
          let isConsents = $(el).find('.expertGuidance__section__text').find('.border-red-300');
          if(isConsents.length) {return;}
          const inputField = $(el).find(".expertGuidanceForm__inner__field").find('input');
          $(inputField).each(function(){
          if($(this).prop('required') && $(this).val() == ''){
              $(this).addClass('border-red-300');
              $(this).siblings('.chli_input--error').removeClass('opacity-0');
          }
          });
          const consentCheckbox = $(el).find('.consent__container').find('.expertGuidance__consent--checkbox');
          if(consentCheckbox.prop('required') && !consentCheckbox.is(':checked')){
            consentCheckbox.removeClass('border-blue-400').addClass('border-red-300');
            $(consentCheckbox).siblings('.chli_input--error').removeClass('opacity-0');
          }
          let isError = $(el).find('.expertGuidanceForm__inner__field').find('.border-red-300');
          if(isError.length) {return;}
          let isConsent = $(el).find('.expertGuidance__section__text').find('.border-red-300');
          if(isConsent.length) {return;}
          const formRecaptcha = $(form).data('recaptcha');
          expertGuidanceObj.methods.handleLoader(el, true);
          load(expertGuidanceObj.variables.siteKey).then((recaptcha) => {
            recaptcha.execute('submit').then((token) => {
                let json = formHandler.methods.convertFormToJSON(form);
                if(formRecaptcha){
                  json["g-recaptcha-response"] = token;
                }
                const nameParts = [json["firstName"], json["middleName"], json["lastName"]]
                  .filter((part) => typeof part === "string" && part.trim().length > 0)
                  .map((part) => part.trim());
                if (!json["fullName"] || !json["fullName"].trim()) {
                  if (json["name"] && json["name"].trim()) {
                    json["fullName"] = json["name"].trim();
                  } else if (nameParts.length) {
                    json["fullName"] = nameParts.join(" ");
                  }
                }
                delete json["name"];
                json['leadConsent']= (consentCheckbox && consentCheckbox.is(':checked'))? 'Yes': 'No';
                json['gaId'] = getClientId();
                json['countryCode'] = '+91';
                expertGuidanceObj.variables.name = json["fullName"];
                expertGuidanceObj.variables.email = json["emailID"];
                expertGuidanceObj.variables.dob = json["dob"];
                expertGuidanceObj.variables.countryCode = json["countryCode"];
                expertGuidanceObj.variables.mobileNo = json["mobileNumber"];
                expertGuidanceObj.variables.annualIncome = json["annualIncome"];
                expertGuidanceObj.variables.pincode = json["pincode"];
                expertGuidanceObj.variables.productCategory = json["productCategory"];
                expertGuidanceObj.variables.productName = json["productName"];
                expertGuidanceObj.variables.city = json["city"];
                json = JSON.stringify(json);
                const url = `/bin/expertGuidance`;
                $.ajax({
                  type: "POST",
                  url: url,
                  data: json,
                  contentType: "application/json",
                  dataType: "json",
                }).done((response) => {
                  expertGuidanceObj.methods.buttonClickHandler(el,response);
                  expertGuidanceObj.methods.handleLoader(el, false);
                  const responseContainer = $(el).find('.thankyou');
                  if(expertGuidanceObj.variables.city && expertGuidanceObj.variables.city.toLowerCase() !== 'other'){
                    const thankyouTextContainer = $(el).find('.thankyou-text');
                    let validCityMessage = $(el).closest('.expertGuidance__section').data('valid-city-message');
                    const nameText = $(el).find('.expertGuidanceForm__firstName')?.find('input')?.val() 
                      || $(el).find('.expertGuidanceForm__name').find('input').val().split(' ')[0];                   
                    validCityMessage = validCityMessage.replace('${customerName}', nameText);
                    thankyouTextContainer.html(validCityMessage);
                    responseContainer.removeClass('d-none');
                  } else if (!expertGuidanceObj.variables.city || (expertGuidanceObj.variables.city &&  expertGuidanceObj.variables.city.toLowerCase() == 'other')){ 
                    const thankyouTextContainer = $(el).find('.thankyou-text');
                    let otherCityMessage = $(el).closest('.expertGuidance__section').data('other-city-message');
                    const nameText = $(el).find('.expertGuidanceForm__firstName')?.find('input')?.val() 
                      || $(el).find('.expertGuidanceForm__name').find('input').val().split(' ')[0];
                    otherCityMessage = otherCityMessage.replace('${customerName}', nameText);
                    thankyouTextContainer.html(otherCityMessage);
                    responseContainer.removeClass('d-none');
                  }else{
                    const responseContainer = $(el).find('.thankyou');
                    const nameText = $(el).find('.expertGuidanceForm__firstName')?.find('input')?.val() 
                      || $(el).find('.expertGuidanceForm__name').find('input').val().split(' ')[0];
                    $(el).find('.thankyou__response').find('span').html(nameText);
                    responseContainer.removeClass('d-none');
                  }
                  
                  $('body').addClass('overflow-hidden');
                }).catch((error,response) => {
                  console.error(error);
                  expertGuidanceObj.methods.handleLoader(el, false);
                });
            })
          }).catch(err=>{
            expertGuidanceObj.methods.handleLoader(el, false);
            console.log(err);
          });
        })
      })
    }
  },
  init: function () {
    $(window).width() < 992
      ? this.methods.changeBg(
          expertGuidanceObj.variables.bgMob,
          expertGuidanceObj.variables.bgMobAlt
        )
      : this.methods.changeBg(
          expertGuidanceObj.variables.bg,
          expertGuidanceObj.variables.bgDeskAlt
        );

    $(window).width() > 992 &&
      this.methods.changeAlignment(expertGuidanceObj.variables.fieldCount);
    $('.expertGuidance__section').each((idx, ele)=>{
        expertGuidanceObj.methods.closeSection(ele);
        expertGuidanceObj.methods.handleSubmit(ele);
        expertGuidanceObj.methods.validateInput(ele);
    })
  },
};

$(() => {
  if ($(".expertGuidance__section").length > 0) {
    expertGuidanceObj.init();
  }
});
